// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + "ac54bfdbdbc516128ec0" + ".chunk.js";
};